import { createAction, props } from "@ngrx/store";
import { Clients } from '../models/clients.model';
import { ClientsProfile } from '../models/clients-profile.model';
export const clientsDetails = createAction(
    '[Clients data] Retrieve cllients data', props<{ clientsData: Record<string, string>[] }>()
)
export const clientsProfile = createAction(
    '[Clients Profile] Retrieve Clients profile data', props<{ clientsProfileData: ClientsProfile[] }>()
)
